<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="excelImportForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="excelImport" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                excelImportForm: () => import('../forms/ExcelImportForm'),
                excelImport: () => import('../editViews/ExcelImport'),
                headers: [
                    { text: 'Name', value: 'name' },
                    { text: 'Imported On', value: 'importedOn', format: this.formatDateTime },
                    { text: 'File', value: 'fileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    files: [],
                    users: [],
                    items: []
                },
                sorting: [
                    { column: "importedOn", direction: "descending" },
                    { column: "name", direction: "ascending" },
                    { column: "userId", direction: "ascending" },
                    { column: "fileId", direction: "ascending" },
                ],
                itemsField: 'excelImports',
                editPageName: 'excelImport',
                apiMethod: 'ExcelImports',
                claimName: 'ExcelImports',
                formTitle: 'Excel Import',
                excelTitle: 'Excel Imports',
                hasEditPage: true,
            }
        },
    };
</script>
